import { Link } from 'react-router-dom';
import { siteStats, comments } from '@/mocks';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  const orgLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51吃瓜网站',
    url: 'http://genulv.cn/',
    logo: 'http://genulv.cn/vite.svg',
    description: '聚合全网最新黑料吃瓜，速递今日大瓜全纪录，直击网红明星塌房现场。独家资源集散第一站。',
  };

  const webpageLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '关于我们 - 51吃瓜网站',
    description: '了解51吃瓜网站的品牌故事、平台使命、内容标准和联系方式。',
    url: 'http://genulv.cn/about',
    inLanguage: 'zh-CN',
    isPartOf: { '@type': 'WebSite', name: '51吃瓜网站', url: 'http://genulv.cn/' },
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 md:pt-24">
        <section className="relative py-16 md:py-24 flex items-center justify-center overflow-hidden bg-foreground-950">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20digital%20network%20connection%20concept%2C%20glowing%20nodes%20and%20data%20streams%2C%20dark%20background%20with%20warm%20red%20and%20orange%20highlights%2C%20modern%20technology%20visualization%2C%20cinematic%20artistic%20rendering&width=1920&height=800&seq=about-hero-01&orientation=landscape"
              alt="关于51吃瓜"
              className="w-full h-full object-cover object-top opacity-40"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
          </div>
          <div className="relative z-10 container-custom text-center">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-4">
              关于 <span className="text-primary-400">51吃瓜</span>
            </h1>
            <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto leading-relaxed">
              聚合全网最新黑料吃瓜，速递今日大瓜全纪录，直击网红明星塌房现场。
              <br className="hidden md:block" />
              作为独家资源集散第一站，我们致力于为用户提供最真实、最及时的娱乐爆料资讯。
            </p>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100">
          <div className="container-custom">
            <div className="text-center mb-10 md:mb-12">
              <p className="text-sm text-foreground-500 font-serif italic mb-3">值得信赖的娱乐爆料平台</p>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950">
                全网领先的
                <br />
                <span className="font-serif italic text-primary-600">吃瓜资讯聚合平台</span>
              </h2>
              <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-xl mx-auto">
                自创立以来，51吃瓜网站始终秉持真实、客观、及时的原则，为用户筛选最有价值的娱乐爆料资讯
              </p>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mb-10 md:mb-12">
              {siteStats.map((stat) => (
                <div key={stat.label} className="text-center p-4 md:p-6 rounded-xl bg-background-50 border border-background-200">
                  <p className="text-2xl md:text-3xl font-bold text-primary-600">{stat.value}</p>
                  <p className="text-sm text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
              <div className="p-6 md:p-8 rounded-2xl bg-accent-500/10 border border-accent-200">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="text-lg md:text-xl font-semibold text-foreground-950 mb-2">平台使命</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      打破娱乐圈信息不对称，让每一个吃瓜群众都能获取真实可靠的爆料资讯。我们不生产瓜，只做全网优质黑料的搬运工与筛选者。
                    </p>
                  </div>
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 text-accent-600 flex-shrink-0">
                    <i className="ri-focus-3-line text-lg" />
                  </span>
                </div>
              </div>
              <div className="p-6 md:p-8 rounded-2xl bg-secondary-500/10 border border-secondary-200">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="text-lg md:text-xl font-semibold text-foreground-950 mb-2">内容标准</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      所有发布内容均经过严格的事实核查，基于截图、录音、视频等实锤证据。我们拒绝谣言，坚持有据可查，有图有真相的爆料原则。
                    </p>
                  </div>
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 text-secondary-600 flex-shrink-0">
                    <i className="ri-shield-check-line text-lg" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="container-custom">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
                用户口碑
              </h2>
              <p className="text-sm text-foreground-500">
                来自真实用户的评价与反馈
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
              {comments.map((comment) => (
                <div key={comment.id} className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200">
                  <div className="flex items-center gap-3 mb-3">
                    <img
                      src={comment.avatar}
                      alt={comment.username}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <p className="text-sm font-medium text-foreground-800">{comment.username}</p>
                      <div className="flex items-center gap-0.5 text-accent-500 text-xs">
                        {Array.from({ length: comment.rating }).map((_, i) => (
                          <i key={i} className="ri-star-fill" />
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {comment.content}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100">
          <div className="container-custom max-w-3xl text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mb-8 leading-relaxed">
              如果您有任何建议、反馈或爆料线索，欢迎随时与我们联系。我们将尽快回复您的来信。
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
              <div className="p-4 md:p-5 rounded-xl bg-background-50 border border-background-200 text-center">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 mx-auto mb-2">
                  <i className="ri-mail-line text-lg" />
                </span>
                <p className="text-sm font-medium text-foreground-800">商务合作</p>
                <p className="text-xs text-foreground-500 mt-1">hello@genulv.cn</p>
              </div>
              <div className="p-4 md:p-5 rounded-xl bg-background-50 border border-background-200 text-center">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-50 text-accent-600 mx-auto mb-2">
                  <i className="ri-message-3-line text-lg" />
                </span>
                <p className="text-sm font-medium text-foreground-800">爆料投稿</p>
                <p className="text-xs text-foreground-500 mt-1">hello@genulv.cn</p>
              </div>
              <div className="p-4 md:p-5 rounded-xl bg-background-50 border border-background-200 text-center">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-50 text-secondary-600 mx-auto mb-2">
                  <i className="ri-customer-service-line text-lg" />
                </span>
                <p className="text-sm font-medium text-foreground-800">意见反馈</p>
                <p className="text-xs text-foreground-500 mt-1">hello@genulv.cn</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageLd) }} />
    </div>
  );
}
